import { render, staticRenderFns } from "./UploadForms.vue?vue&type=template&id=4b612d40&"
import script from "./UploadForms.vue?vue&type=script&lang=js&"
export * from "./UploadForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports